import { Routes, Route } from "react-router";

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Events from "./components/Events";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import DividerMedallion from "./components/DividerMedallion";
import GalleryPreview from "./components/GalleryPreview";
import Gallery from "./components/Gallery";
import ScrollToHash from "./components/ScrollToHash";

function HomePage() {
  return (
    <>
      <ScrollToHash />
      <Header />

      <main>
        <Hero />

        <About />

        <DividerMedallion />

        <Events />

        <DividerMedallion />

        <GalleryPreview />

        <Reviews />

        <Contact />
      </main>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />

      {/* <Route path="/gallery" element={<Gallery />} /> */}
    </Routes>
  );
}
